export const DEFAULT_LP_SLIPPAGE = 0.001;
